module.exports = {
    faq: [
      {
        id: 1,
        question: "How does Open Bonnet benefit my workshop?",
        answer: "Open Bonnet increases your workshop's visibility, provides access to a broader customer base, offers efficient management tools, and supports marketing initiatives, leading to increased revenue and growth opportunities.",
      },
      {
        id: 2,
        question: "Is there a cost associated with joining Open Bonnet as a partner?",
        answer: <>Open Bonnet offers flexible partnership options, including free and premium plans. The cost depends on the level of services and features you choose. We have plans tailored to accommodate various workshop sizes and needs. Give know more pop – up link and give the below information –<br/><br/>  Our premium Package includes - <br/><br/>  ONE MONTH PACKAGE, INCLUDES:<br/> Full month listing: <br/> a. Open Bonnet website ‘partner spotlight’ <br/>  b. Website Platform – Home Screen Banner<br/> <br/> 2. Two times in one month:<br/> <br/>   a. Website partner spotlight, OB choice (flag) (recommended listing)<br/> b. Social Post/ Banner (Facebook/ Instagram/ Twitter/ Linkedin/ Google) / <br/> c. Home Page Banner <br/> d. Double cashpoints for your workshop funded by OB<br/><br/>  Total Cost for the One Month Package:  AED 5000 only!<br/><br/>  Contact us for customized package quote – +971 58 951 2500</>,
      },
      {
        id: 3,
        question: "How does Open Bonnet handle customer feedback and reviews?",
        answer: "Open Bonnet allows customers to leave feedback and reviews after service appointments. We encourage honest feedback as it helps workshops improve their services. Workshops can respond to reviews and address customer concerns, fostering positive relationships.",
      },
      {
        id: 4,
        question: "What marketing support does Open Bonnet provide to workshops?",
        answer: "Open Bonnet offers various marketing initiatives, including online promotions, social media exposure, and targeted marketing campaigns. We also provide workshops with promotional materials and templates to enhance their marketing efforts.",
      },
      {
        id: 5,
        question: "Is there a minimum contract period for partnering with Open Bonnet?",
        answer: "Open Bonnet offers flexible partnership agreements with no minimum contract period. Workshops can choose to partner with us on a month-to-month basis. We believe in providing workshops the freedom to decide what works best for their business.",
      },
      {
        id: 6,
        question: "How are payments processed for services booked through Open Bonnet?",
        answer: "Payments for services booked through Open Bonnet are securely processed online. Once the service is completed and the customer is satisfied, the payment is transferred to your workshop's account using our secure payment gateway by Mamopay.",
      },
      {
        id: 7,
        question: "Does Open Bonnet offer Buy Now Pay Later Solutions for the offered service jobs?",
        answer: "Yes, at Open Bonnet Job/Service purchasers have the option of fulfilling the payment through tabby pay.",
      },
      {
        id: 8,
        question: "Can I track the performance of my workshop on Open Bonnet?",
        answer: "Yes, workshops have access to a comprehensive dashboard where they can track performance metrics, customer feedback, and service bookings. Our analytics tools provide valuable insights to help workshops optimize their operations and enhance customer satisfaction.",
      },
    ],
  };
  